import { getFrontendURL } from 'src/utils/url';
import { SectionButtonDescriptor } from 'src/pages/OfferPage/DocuSectionButtons/docuSectionButtonDefs';
import { SetPropertyRequest, useSetProjectQuoteUserPropertyMutation } from 'src/api/v1/project-ApiSlice';
import { useParams } from 'react-router';
import { useAppDispatch } from 'src/app/hooks';
import { toggleFloorPlanVisible, toggleRoomFloorPlansVisible, } from 'src/api/project-quote-ui-slice';

export const ToggleSwitch = ({buttonDesc, disableCursor = false}: {
  buttonDesc: SectionButtonDescriptor,
  disableCursor?: boolean
}) => {

  const dispatch = useAppDispatch();
  const params = useParams<{ projectId: string }>();
  const [ updateProperty ] = useSetProjectQuoteUserPropertyMutation();

  return (
    <label className="tgl-switch">
      <input
        type="checkbox"
        defaultChecked={buttonDesc.state === 1}
      />
      <img
        src={
          buttonDesc.state===1 ? `${getFrontendURL()}/images/eye_active.svg` : `${getFrontendURL()}/images/eye_inactive.svg`
        }
        style={{
          color: "black",
          fontSize: 22,
          lineHeight: "42px",
          height: 40,
          width: 30,
          textAlign: "center",
          cursor: disableCursor ? "not-allowed" : "pointer",
        }}
        onClick={(e) => {
          if (disableCursor) {
            return;
          }
          if (buttonDesc.type === 'normal') {
            let newState = (buttonDesc.state === 1) ? 0 : 1
            updateProperty({
              projectId: +(params.projectId!!),
              propertyKey: buttonDesc.propertyKey,
              value: newState
            } as SetPropertyRequest)
          } else if (buttonDesc.type === 'floor') {
            dispatch(toggleFloorPlanVisible(buttonDesc.floorId!!))
          } else if (buttonDesc.type === 'floor_rooms') {
            dispatch(toggleRoomFloorPlansVisible(buttonDesc.floorId!!))
          }
          e.stopPropagation();
        }}
      />
    </label>
  );
};
